module.exports = __webpack_public_path__ + "img/194.c8e81c1d.jpg";